module.exports = __webpack_public_path__ + "media/images/icons/personal-statement-eaebc3f19271ed3c22ce198daa2510c0.svg";